import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AgGridAngular} from 'ag-grid-angular';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {buttons, buttonsCss, mensajes} from 'src/assets/data/diccionario';

import {ReportService} from '../../services/reporte-facturacion-electronica/report.service';


@Component({
  selector: 'app-reporte',
  templateUrl: './reporte.component.html',
  styleUrls: ['./reporte.component.css']
})
export class ReporteComponent implements OnInit {
  formulario: FormGroup;
  mostrarFormulario = false;
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  editableForm = false;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;
  ListcrtStatusDoc: any[];
  buscarparametro: any[];
  @ViewChild('agGrid') agGrid: AgGridAngular;
  rowData;
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;
  textBoton: string;
  orden: boolean;
  model: any;
  temp: any;
  params: any;
  listaVacia: boolean = true;
  loading: boolean = false;

  constructor(private fb: FormBuilder,
              private _reporte: ReportService,
              private _util: UtilsService) {
  }

  ngOnInit() {

    this.obtenerTodo();
    this.DAT_BTNS = buttons;
    this.DAT_MSG = mensajes;
    this.DAT_BTNCSS = buttonsCss;

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.ListcrtStatusDoc = [{id: 'PENDIENTE', valor: 'Pendiente'},
      {id: 'REGISTRADO', valor: 'Registrado'},
      {id: 'ERROR', valor: 'Error'}];

    this.formulario = this.fb.group({
      ctrStatusDoc: ['', [Validators.required]],
      fechaInicial: ['', []],
      fechaFinal: ['', []],
      caja: ['', []]
    });

    this.columnDefs = [
      {
        headerName: 'TIPO DOC.',
        field: 'nombreTipo',
        // checkboxSelection: true,
        // headerCheckboxSelection: true,
        lockPosition: true,
        resizable: true,
        width: 130,
        sortable: true
      },
      {
        headerName: '# DOCUMENTOS',
        resizable: true,
        valueGetter(params) {
          return (params.data.establecimiento) + '---'
            + (params.data.puntoEmision) + '---'
            + (params.data.secuencial);
        },
        sortable: true
      },
      {
        headerName: 'F. EMISION',
        field: 'fechaEmision',
        width: 140,
        // cellEditor: 'datePicker',
        resizable: true,
        sortable: true
      },
      {
        headerName: 'RUC',
        field: 'ruc',
        resizable: true,
        width: 200,
        sortable: true
      },
      {
        headerName: 'RAZON SOCIAL',
        field: 'razonSocial',
        resizable: true,
        width: 190,
        sortable: true
      },
      {
        headerName: 'IMPORTE',
        field: 'importeTotal',
        resizable: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'ORDEN',
        field: 'orden',
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        headerName: 'STATUS',
        field: 'ctrStatusDoc',
        resizable: true,
        width: 130,
        sortable: true
      },
      {
        headerName: 'OBSERVACION',
        field: 'observacion',
        resizable: true,
        width: 300,
        sortable: true
      },
    ];
    this.rowSelection = 'multiple';
  }

  obtenerTodo() {
    this.loading = true;
    this._reporte.getAll().subscribe(res => {
      console.log(res);
      this.loading = false;
      this.rowData = res;
      this.listaVacia = false;
    }, error => {
      console.log(error);
      this.loading = false;
      this.listaVacia = true;
      this._util.mensajeErrorVisto(error.error.message);
    });
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  getSelectedRows() {
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data);
    if (this.formulario.get('caja').value !== null &&
      this.formulario.get('caja').value !== '') {
      let flag = true;
      selectedData.filter((item) => {
        if (item.ctrStatusDoc === 'REGISTRADO') {
          flag = false;
          return;
        }
        item.orden = this.formulario.get('caja').value;
      });
      if (flag === true) {
        this._reporte.actualizarOrden(selectedData).subscribe(res => {
          this.rowData = res;
          //  this._util.mensajeOKVisto('Se Registro la Orden Correctamente');
          this.obtenerTodo();
        });
      } else {
        this._util.mensajeErrorVisto('No se puede cambiar Status Registrado');
      }
    } else {
      this._util.mensajeErrorVisto('Por favor llenar con la Información Deseada');
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  buscarParametros() {
    this.loading = true;
    this._reporte.getParametro(this._util.formatofecha(this.formulario.get('fechaInicial').value),
      this._util.formatofecha(this.formulario.get('fechaFinal').value),
      this.formulario.get('ctrStatusDoc').value).subscribe((res) => {
      this.rowData = res;
      this.listaVacia = false;
      this.loading = false;
    }, (err) => {
      this._util.mensajeErrorVisto(err.error.mensaje);
      this.listaVacia = true;
      this.loading = false;
    });
  }
}
